export class AsyncData<T, E = string> {
  constructor(public loaded: boolean, public data?: T, public error?: E) {}
}
